var plugins = [{
      plugin: require('/opt/atlassian/pipelines/agent/build/website/node_modules/gatsby-plugin-jss/gatsby-browser'),
      options: {"plugins":[],"theme":{"colours":{"palette":{"blue":"#42aad8","green":"#63da38","purple":"#d078e4","orange":"#ff9500","red":"#DE4C4C","pink":"#ff2968","yellow":"#eabb00","white":"#fff","lightGrey":"rgba(255, 255, 255, 0.4)"},"content":{"fontColor":"#444","fontWeight":"200px","backgroundColor":"#F1F1F1"},"products":{"mp":"#63da38","scot":"#d078e4","mla":"#ff9500","td":"#DE4C4C","gov":"#ff2968","voter":"#eabb00"}},"text":{"fontSize":"1.3rem","textAlign":"left"},"headings":{"fontSize":"5.5rem","textAlign":"center"},"hoverColor":"rgba(255, 255, 255, 0.1)"}},
    }]
// During bootstrap, we write requires at top of this file which looks
// basically like:
// var plugins = [
//   {
//     plugin: require("/path/to/plugin1/gatsby-browser.js"),
//     options: { ... },
//   },
//   {
//     plugin: require("/path/to/plugin2/gatsby-browser.js"),
//     options: { ... },
//   },
// ]

export function apiRunner(api, args, defaultReturn) {
  let results = plugins.map(plugin => {
    if (plugin.plugin[api]) {
      const result = plugin.plugin[api](args, plugin.options)
      return result
    }
  })

  // Filter out undefined results.
  results = results.filter(result => typeof result !== `undefined`)

  if (results.length > 0) {
    return results
  } else if (defaultReturn) {
    return [defaultReturn]
  } else {
    return []
  }
}

export function apiRunnerAsync(api, args, defaultReturn) {
  return plugins.reduce(
    (previous, next) =>
      next.plugin[api]
        ? previous.then(() => next.plugin[api](args, next.options))
        : previous,
    Promise.resolve()
  )
}



// WEBPACK FOOTER //
// ./.cache/api-runner-browser.js